<template>
  <v-row
    no-gutters
    class="sn-table-action-bar d-flex mb-4"
  >
    <!-- Search Box -->
    <sn-search
      v-if="searchEnabled"
      :pendo="snInputProps_pendo"
      :value="searchOptions.text"
      @search="search"
    />

    <sn-table-filter-chip
      v-for="filterSummary in filterSummaries"
      :key="filterSummary.header.text"
      :filter-summary="filterSummary"
      @clear="clearFilter(filterSummary)"
      @change="applySortFilterChange"
    />

    <!-- Action Buttons -->
    <div class="sn-table-actions d-flex ml-auto">
      <!-- Tertiary Actions -->
      <v-menu
        v-if="tertiaryActions"
        tile
        left
        offset-y
        allow-overflow
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            data-cy="table-tertiary-action-btn"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>$snMenuDotsHorizontalSolid</v-icon>
          </v-btn>
        </template>
        <v-list data-cy="tertiary-dropdown-list">
          <v-list-item
            v-for="(action) in tertiaryActions"
            :key="action.actionIndex"
            link
            @click="$emit('tertiary-action', action.actionIndex)"
          >
            <v-list-item-icon v-if="action.actionIcon">
              <v-icon>{{ action.actionIcon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ action.actionText }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Secondary Action -->
      <sn-btn
        v-if="secondaryAction"
        type="secondary"
        size="standard"
        class="ml-3"
        data-cy="table-secondary-action-btn"
        :prepend-icon="secondaryAction.actionIcon"
        :text="secondaryAction.actionText"
        :data-pendo="snInputProps_pendo + '-SecondaryAction'"
        @click="$emit('secondary-action')"
      />

      <!-- Primary Action -->
      <sn-btn
        v-if="primaryAction"
        type="primary"
        size="standard"
        class="ml-3"
        data-cy="table-primary-action-btn"
        :prepend-icon="primaryAction.actionIcon"
        :text="primaryAction.actionText"
        :data-pendo="snInputProps_pendo + '-PrimaryAction'"
        @click="$emit('primary-action')"
      />
    </div>
  </v-row>
</template>

<script>
import SnBtn from '~/components/snui/v2/snBtn/snBtn'
import SnSearch from '~/components/snui/v2/snSearch/snSearch'
import SnInputProps from '~/components/snui/v2/props/SnInputProps'
import SnTableFilterChip from './snTableFilterChip'

export default {
  name: 'SnTableActionBar',
  components: {
    SnTableFilterChip,
    SnBtn,
    SnSearch
  },
  props: {
    ...SnInputProps,
    /**
     * Primary action button display information
     * Schema: { actionText: string, actionIcon: string? }
     */
    primaryAction: {
      type: Object,
      default () { return null }
    },
    /**
     * Secondary action button display information
     * Schema: { actionText: string, actionIcon: string? }
     */
    secondaryAction: {
      type: Object,
      default () { return null }
    },
    /**
     * Tertiary actions dropdown display information
     * Schema: list of { actionIndex: int, actionText: string, actionIcon: string? }
     * Will be sorted by index and the click will be emitted with index as identifier
     */
    tertiaryActions: {
      type: Array,
      default () { return null }
    },
    searchEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    searchOptions: {
      type: Object,
      required: false,
      default: () => {
        return {
          label: 'Search',
          text: ''
        }
      }
    },
    filterSummaries: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    search (searchText) {
      this.$emit('search-table', searchText)
    },
    clearFilter (filterSummary) {
      this.$emit('clear-filter', filterSummary)
    },
    applySortFilterChange (values) {
      this.$emit('sort-filter-changed', values)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.sn-table-action-bar {
  height: 48px;
  margin-bottom: 16px;

  .sn-table-actions {
    margin-top: 6px;
    margin-bottom: 6px;
  }
}

</style>
